import { render, staticRenderFns } from "./SyncProduct.vue?vue&type=template&id=4260b0e1&scoped=true"
import script from "./SyncProduct.vue?vue&type=script&lang=js"
export * from "./SyncProduct.vue?vue&type=script&lang=js"
import style0 from "./SyncProduct.vue?vue&type=style&index=0&id=4260b0e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4260b0e1",
  null
  
)

export default component.exports